export default __webpack_public_path__ + "static/media/nt_partlycloudy.5101bff5.svg";